import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Vector"
      d="M12.2 16.7C12.4387 16.7 12.6676 16.6052 12.8364 16.4364C13.0052 16.2676 13.1 16.0387 13.1 15.8V2.3H5.9C5.6613 2.3 5.43239 2.39482 5.2636 2.5636C5.09482 2.73239 5 2.96131 5 3.2V13.1H3.2V3.2C3.2 2.48392 3.48446 1.79716 3.99081 1.29081C4.49716 0.784464 5.18392 0.5 5.9 0.5H15.8C16.5161 0.5 17.2028 0.784464 17.7092 1.29081C18.2155 1.79716 18.5 2.48392 18.5 3.2V4.1H16.7V3.2C16.7 2.96131 16.6052 2.73239 16.4364 2.5636C16.2676 2.39482 16.0387 2.3 15.8 2.3C15.5613 2.3 15.3324 2.39482 15.1636 2.5636C14.9948 2.73239 14.9 2.96131 14.9 3.2V6.8V15.8C14.9 16.5161 14.6155 17.2028 14.1092 17.7092C13.6028 18.2155 12.9161 18.5 12.2 18.5H3.2C2.48392 18.5 1.79716 18.2155 1.29081 17.7092C0.784464 17.2028 0.5 16.5161 0.5 15.8V14.9H10.4C10.4 15.3774 10.5896 15.8352 10.9272 16.1728C11.2648 16.5104 11.7226 16.7 12.2 16.7Z"
      fill="#222A5C"
    />
  </svg>,
  "Script"
);
